import iconEvent from 'assets/images/eventBunpimay/iconTextEvent.png'
import iconTop1 from 'assets/images/eventBunpimay/iconTop1Prize.png'
import iconTop2 from 'assets/images/eventBunpimay/iconTop2Prize.png'
import iconTop3 from 'assets/images/eventBunpimay/iconTop3Prize.png'
import iconPhone from 'assets/images/eventBunpimay/samsung.png'
import iconHeadphone from 'assets/images/eventBunpimay/headphonePrize.png'
import iconMoney from 'assets/images/eventBunpimay/moneyPrize.png'
import iconTopRight from 'assets/images/eventBunpimay/iconTopRight.png'
import iconTopLeft from 'assets/images/eventBunpimay/iconTopLeft.png'
import { useTranslation } from 'react-i18next'
import CustomTable from 'pages/Event/EventWater/CustomTable'

function EventBunpimayDetail() {
	const { t } = useTranslation()
	const columns = [
		{
			title: t('event.bunpimay.detail.transaction'),
			dataIndex: 'package',
			align: 'center',
			width: '50%'
		},
		{
			title: t('event.bunpimay.detail.number_gun'),
			dataIndex: 'number',
			align: 'center',
			width: '50%'
		},
	]
	const columnsPlayGame = [
		{
			title: t('event.bunpimay.detail.transaction'),
			dataIndex: 'result',
			align: 'center',
			width: '50%'
		},
		{
			title: t('event.bunpimay.detail.number_water'),
			dataIndex: 'number',
			align: 'center',
			width: '50%'
		},
	]

	const data = [
		{
			package: t('event.bunpimay.detail.register'),
			number: '5',
		},
		{
			package: t('event.bunpimay.detail.package_1'),
			number: '4',
		},
		{
			package: t('event.bunpimay.detail.package_2'),
			number: '9',
		},
		{
			package: t('event.bunpimay.detail.package_3'),
			number: '20',
		},
		{
			package: t('event.bunpimay.detail.package_4'),
			number: '53',
		},
		{
			package: t('event.bunpimay.detail.package_5'),
			number: '110',
		},
	]
	const dataPlaygame = [
		{
			result: t('event.bunpimay.detail.winning'),
			number: '10',

		},
		{
			result: t('event.bunpimay.detail.losing'),
			number: '5',
		},
	]
	return (
		<div className="box-detail">
			<div className="box-prize-description">
				<img
					draggable="false"
					className="icon-event"
					srcSet={`${iconEvent} 2x`}
				/>
			</div>
			<div className="box-detail-content">
				<img draggable="false" className='icon-top-right' src={iconTopRight} />
				<img draggable="false" className='icon-top-left' src={iconTopLeft} />
				<div className="wapper-detail-box-content">
					<p level={3} className="wapper-detail-box-content-title">
						{' '}
						<span>{t('event.bunpimay.detail.title')}</span>
					</p>
					<p>
						<span>{t('event.bunpimay.detail.text_d1_1')}</span>{' '}
						{t('event.bunpimay.detail.text_d1_2')}
					</p>

					<p>
						<span>{t('event.bunpimay.detail.text_d2_1')} </span>
						{t('event.bunpimay.detail.text_d2_2')}
						<ul>
							<li>{t('event.bunpimay.detail.text_d3')}</li>
							<li>{t('event.bunpimay.detail.text_d4')}</li>
							<li>{t('event.bunpimay.detail.text_d5')}</li>
						</ul>
					</p>

					<span>{t('event.bunpimay.detail.text_d6_1')}</span>
					<p>{t('event.bunpimay.detail.text_d6_2')}</p>
					<p>
						<span>{t('event.bunpimay.detail.text_d7_1')} </span>
						{t('event.bunpimay.detail.text_d7_2')}
					</p>
					<p>
						{t('event.bunpimay.detail.text_d8_1')}
					</p>
					<p className='text-indent'>{t('event.bunpimay.detail.text_d8_2')}</p>
					<CustomTable
						columns={columnsPlayGame}
						dataSource={dataPlaygame}
						style={{ marginBottom: '1em' }}
						pagination={false}
						scroll={{ x: true }}
						bordered
					/>

					<p className='text-indent'>{t('event.bunpimay.detail.text_d8_3')}</p>
					<CustomTable
						columns={columns}
						dataSource={data}
						style={{ marginBottom: '1em' }}
						pagination={false}
						scroll={{ x: true }}
						bordered
					/>
					<p>{t('event.bunpimay.detail.text_d10')}</p>
					<p>{t('event.bunpimay.detail.text_d11')}</p>
					<p>{t('event.bunpimay.detail.text_d12')}</p>
				</div>
			</div>
		</div>
	)
}

export default EventBunpimayDetail
